import React from "react";
import PropTypes from "prop-types";
import Toggle from "../../components/ui-components/Toggle";

export const INTERVAL_OPTIONS = [
  { value: "auto", label: "Auto" },
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

// IntervalSelect — the aggregation GRANULARITY of the time-series.
//
// It lives in the chart header rather than the page toolbar, unlike Breakdown
// and Basis. The dividing line is scope: Breakdown, Basis and filters redefine
// what the WHOLE analyzer is showing — the drivers table and attribution panel
// included — while this control and Cumulative change only the one chart they
// sit on. (This reverses an earlier ruling that put Cumulative in the toolbar.)
//
// Every option stays enabled. "This month" + Month yields a single bar, which is
// a legitimate period-level financial view, not a mistake to prevent.
export default function IntervalSelect({ value, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] font-medium uppercase tracking-[0.04em] text-text-3">Interval</span>
      <Toggle style="active-draft" items={INTERVAL_OPTIONS} value={value} changeHandler={onChange} />
    </div>
  );
}

IntervalSelect.propTypes = {
  value: PropTypes.oneOf(["auto", "day", "week", "month"]).isRequired,
  onChange: PropTypes.func.isRequired,
};
